import { render, staticRenderFns } from "./questionWrite.vue?vue&type=template&id=18a354a3&scoped=true&"
import script from "./questionWrite.vue?vue&type=script&lang=js&"
export * from "./questionWrite.vue?vue&type=script&lang=js&"
import style0 from "./questionWrite.vue?vue&type=style&index=0&id=18a354a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a354a3",
  null
  
)

export default component.exports